import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import isEmpty from 'lodash/isEmpty';

import Icon from '../Icon';
import InfoPopover from '../InfoPopover';
import ClickableElement from '../ClickableElement';
import ProgressBar from '../common/ProgressBar';
import { COLORS } from '../../constants/styles';

import styles from './index.styl';

const Header = ({
  icon,
  title,
  subtitle,
  note,
  status,
  locked,
  description,
  openPopover,
  showPopover,
  closePopover,
  reverseTitle,
  progress,
  list,
  intl: { formatMessage },
}) => {
  const anchorRef = useRef(null);

  return (
    <div ref={anchorRef}>
      <div
        styleName={classNames('header', {
          'header--locked': locked,
        })}
        className="bsw2-1 relative"
      >
        <div styleName="headerMain">
          {icon && (
            <Fragment>
              {typeof icon !== 'string' ? (
                icon
              ) : (
                <Icon name={icon} size={32} className="mr2" />
              )}
            </Fragment>
          )}
          <div
            styleName="headerTitle"
            className={classNames({ [styles.reverseTitle]: reverseTitle })}
          >
            {subtitle && (
              <span styleName="text--complementary">{subtitle}</span>
            )}
            <div className="flex items-center">
              <p
                styleName={classNames('text--primary', {
                  'text--short': description,
                })}
                className="mr2"
              >
                {title}
              </p>
              {!isEmpty(description || list) && (
                <ClickableElement onClick={openPopover}>
                  <Icon
                    name="info-default"
                    size={16}
                    style={{ fill: COLORS.bluePrimary }}
                    className="db"
                  />
                </ClickableElement>
              )}
            </div>
          </div>
        </div>

        <div className="tr">
          {status && (
            <div styleName="headerSub" className="pb1">
              {status}
            </div>
          )}
          {note && <div styleName="headerSub">{note}</div>}
        </div>
      </div>
      {progress && <ProgressBar progress={progress} />}
      <InfoPopover
        formatMessage={formatMessage}
        onClose={closePopover}
        isOpen={showPopover}
        description={description}
        anchorEl={anchorRef.current}
        list={list}
      />
    </div>
  );
};

Header.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  note: PropTypes.any,
  locked: PropTypes.bool,
  description: PropTypes.string,
  openPopover: PropTypes.func,
  closePopover: PropTypes.func,
  showPopover: PropTypes.bool,
  progress: PropTypes.number,
  list: PropTypes.array,
  intl: PropTypes.object,
  status: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
};

export default injectIntl(CSSModules(Header, styles, { allowMultiple: true }));



// WEBPACK FOOTER //
// ./src/components/ExpandableListItem/Header.jsx